var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opener opener--alphabet" }, [
    _c(
      "ul",
      { ref: "container", staticClass: "opener__list" },
      [
        _vm._l(_vm.list, function(product, index) {
          return [
            _vm.opened.index === index
              ? _c(
                  "li",
                  {
                    ref: "showup",
                    refInFor: true,
                    staticClass: "opener__showup"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "opener__close",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.close($event, true)
                          }
                        }
                      },
                      [_vm._v("×")]
                    ),
                    _c("div", { staticClass: "opener__controls" }, [
                      _vm.hasNext
                        ? _c("a", {
                            staticClass: "opener__next icon-right",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.next()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.hasPrev
                        ? _c("a", {
                            staticClass: "opener__prev icon-left",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.prev()
                              }
                            }
                          })
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "opener__card" }, [
                      _c("div", { staticClass: "product-card clearfix" }, [
                        _c(
                          "div",
                          { staticClass: "product-card__img-wrapper clearfix" },
                          [
                            _vm.openedProduct.large_image
                              ? _c("div", {
                                  staticClass: "product-card__preview",
                                  style: {
                                    backgroundImage:
                                      "url(" +
                                      _vm.openedProduct.large_image +
                                      ")"
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "product-card__elements-wrapper" },
                              _vm._l(_vm.openedProduct.vitamins, function(
                                vitamin,
                                index
                              ) {
                                return vitamin.image
                                  ? _c("img", {
                                      staticClass: "product-card__elements",
                                      attrs: { src: "", src: vitamin.image }
                                    })
                                  : _vm._e()
                              }),
                              0
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "product-card__main-content clearfix"
                          },
                          [
                            _c("div", { staticClass: "product-card__top" }, [
                              _c("h1", {
                                staticClass: "product-card__title",
                                domProps: {
                                  textContent: _vm._s(_vm.openedProduct.title)
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "product-card__controls product-card__controls--pos-static"
                                },
                                [
                                  _vm.openedProduct.calendar_stage &&
                                  _vm.navigational
                                    ? _c("a", {
                                        staticClass:
                                          "product-card__calendar-link",
                                        attrs: {
                                          href:
                                            "/calendar/?slider=" +
                                            _vm.openedProduct.calendar_stage
                                        },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.trans.showInCalendar
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.openedProduct.nutricia_url
                                    ? _c("a", {
                                        staticClass:
                                          "product-card__nutricia-link",
                                        attrs: {
                                          href: _vm.openedProduct.nutricia_url,
                                          target: "_blank"
                                        },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.openedProduct
                                              .nutricia_url_label ||
                                              _vm.trans.showInMarket
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _c("div", {
                              staticClass: "product-card__content",
                              domProps: {
                                innerHTML: _vm._s(_vm.openedProduct.text)
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "product-card__controls clearfix"
                              },
                              [
                                _vm.openedProduct.calendar_stage &&
                                _vm.navigational
                                  ? _c("a", {
                                      staticClass:
                                        "product-card__calendar-link",
                                      attrs: {
                                        href:
                                          "/calendar/?slider=" +
                                          _vm.openedProduct.calendar_stage
                                      },
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.trans.showInCalendar
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm.openedProduct.nutricia_url
                                  ? _c("a", {
                                      staticClass:
                                        "product-card__nutricia-link",
                                      attrs: {
                                        href: _vm.openedProduct.nutricia_url,
                                        target: "_blank"
                                      },
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.openedProduct
                                            .nutricia_url_label ||
                                            _vm.trans.showInMarket
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "li",
              {
                ref: "elementsList",
                refInFor: true,
                staticClass: "opener__item",
                class: {
                  "is-active": _vm.opened.element === product.id,
                  "opener__item--top": _vm.isLastLine(index)
                },
                style: {
                  "background-color": product.preview_color
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.open(product.id, index)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "product-preview",
                    class: {
                      "is-active": _vm.opened.element === product.id
                    }
                  },
                  [
                    _c("h3", {
                      staticClass: "product-preview__title",
                      domProps: { textContent: _vm._s(product.name) }
                    }),
                    product.small_image
                      ? _c("div", {
                          staticClass: "product-preview__preview",
                          style: {
                            backgroundImage: "url(" + product.small_image + ")"
                          }
                        })
                      : _vm._e(),
                    _c("a", {
                      staticClass: "product-preview__link",
                      attrs: { href: product.alphabet_url, target: "_blank" }
                    })
                  ]
                )
              ]
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4ec32a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4ec32a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/alphabet/recommended.vue
// module id = 184
// module chunks = 4